// src/features/users/components/UserWorkspaceHeader.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { User } from '../types/user.types';
import { UserStatusBadge } from './UserStatusBadge';

export interface UserWorkspaceHeaderProps {
  user: User;
  actionLoading?: boolean;
  onEdit: () => void;
  onToggleBlocked: () => void;
}

/**
 * Top-of-page header for the user workspace. Same glass Card surface
 * as every other card here, but laid out as identity (name + status
 * badge) plus a small meta list (id, created date) on one side and a
 * reserved action area on the other. Profile operations are delegated to
 * the page so the header remains a presentation component.
 */
export function UserWorkspaceHeader({ user, actionLoading = false, onEdit, onToggleBlocked }: UserWorkspaceHeaderProps) {
  return (
    <Card className="vania-user-workspace-header">
      <div className="vania-user-workspace-header-main">
        <div className="vania-user-workspace-header-identity">
          <h1 className="vania-user-workspace-name">{user.name}</h1>
          <UserStatusBadge status={user.status} />
        </div>

        <dl className="vania-user-workspace-meta">
          <div>
            <dt>شناسه کاربر</dt>
            <dd dir="ltr">{formatPersianNumber(user.id)}</dd>
          </div>
          <div>
            <dt>تاریخ ثبت‌نام</dt>
            <dd dir="ltr">{formatSolarDate(user.createdAt)}</dd>
          </div>
        </dl>
      </div>

      <div className="vania-user-workspace-header-actions">
        <button
          type="button"
          disabled={actionLoading}
          className="vania-user-profile-action-primary"
          onClick={onEdit}
        >
          ویرایش کاربر
        </button>
        <button
          type="button"
          disabled={actionLoading}
          className="vania-user-profile-action-secondary"
          onClick={onToggleBlocked}
        >
          {user.status === 'active' ? 'مسدود کردن' : 'رفع مسدودی'}
        </button>
      </div>
    </Card>
  );
}
